var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_798_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8549 9.70258L13.6386 8.66602L6.46249 15.7686L4.67883 16.8051L11.8549 9.70258Z",
    fill: "#FF9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38745 7.70062L10.1711 6.66406L13.6386 8.66603L11.855 9.70259L8.38745 7.70062Z",
    fill: "#FFEB9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9233 4.08585L12.707 3.04932L10.1711 6.66416L8.38745 7.70072L10.9233 4.08585Z",
    fill: "#FF9911"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0365 1.84174L8.82019 0.805176L12.707 3.04924L10.9233 4.08577L7.0365 1.84174Z",
    fill: "#FFEB9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.855 9.70267L4.67887 16.8052L7.54041 9.63017L3.75781 7.4463L7.03647 1.8418L10.9233 4.08583L8.38747 7.7007L11.855 9.70267Z",
    fill: "#FEDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_798_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.698242 0.805176)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.44735d621560de4a55e79cd1f1bd8238.svg";
export { ForwardRef as ReactComponent };